import { Collection } from 'modules/core/lib/mobx-rest'

import Identifier from 'modules/payroll_employees/store/models/Identifier'

class Identifiers extends Collection<Identifier> {
  get cacheKey(): string {
    return 'identifiers'
  }

  override model() {
    return Identifier
  }

  findByEmployee(employeeId: number) {
    return this.find((identifier) => employeeId === identifier.attributes.employee_id)
  }
}

const singleton = new Identifiers()

export default singleton
